import { Backdrop } from "@mui/material";
// import logo from "../logo.png";
import loading from "../PG23.gif";
export default function Loader() {
  return (
    <div>
      <Backdrop
        sx={{
          color: "#087a75",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: "#bff0ed43",
        }}
        open={true}
      >
        <div className="loading-container">
          <img src={loading} alt="" className="loading-loader" />
        </div>
      </Backdrop>
    </div>
  );
}
